module.exports = __webpack_public_path__ + "static/Calluna-SemiboldIt-webfont-4950c19faa91e4a3059786b827687b88.woff2";